import { planSponsorsGetListCtor } from '@/lib/sponsors/planSponsorsGetList'
import { getPlanSponsorDetailsCtor, axiosInstance as restInstance } from '@/lib/sponsors/planSponsorGetDetails';
import { planSponsorCreateCtor } from '@/lib/sponsors/planSponsorCreate';
import { planSponsorEditCtor } from '@/lib/sponsors/planSponsorEditDetails';
import { planSponsorAddAdminCtor } from '@/lib/sponsors/planSponsorAddAdmin';
import { camelify } from '@/helpers/case';

export default {
  state: {
    sponsors: [],
    sponsor: {},
    sponsorsDetailsArray: [],
    loadingSponsors: true,
    loadingSponsor: true,
    loadingSponsorsArray: true,
    addingSponsor: true,
    editingSponsor: true,
    addingAdmin: true,
  },
  getters: {
    getSponsors(state) {
      return state;
    },
    isLoadingSponsors(state) {
      return state.loadingSponsors;
    },
    sponsors(state) {
      return state.sponsors;
    },
    isLoadingSponsorsArray(state) {
      return state.loadingSponsorsArray;
    },
    isLoadingSponsor(state) {
      return state.loadingSponsor;
    },
    sponsor(state) {
      return state.sponsor;
    },
    sponsorsDetailsArray(state) {
      return state.sponsorsDetailsArray;
    },
    addingSponsor(state) {
      return state.addingSponsor;
    },
    editingSponsor(state) {
      return state.editingSponsor;
    },
    addingAdmin(state) {
      return state.addingAdmin;
    }
  },
  mutations: {
    updateSponsorsData(state, sponsors) {
      Object.assign(state, sponsors);
    },
    setLoadingSponsors(state, loadingSponsors) {
      state.loadingSponsors = loadingSponsors;
    },
    updateSponsors(state, sponsors) {
      state.sponsors = sponsors;
    },
    setLoadingSponsor(state, loadingSponsor) {
      state.loadingSponsor = loadingSponsor;
    },
    updateSponsor(state, sponsor) {
      state.sponsor = sponsor;
    },
    updateSponsorsDetailsArray(state, sponsorsDetailsArray) {
      state.sponsorsDetailsArray = sponsorsDetailsArray;
    },
    setLoadingSponsorsDetailsArray(state, loadingSponsorsArray) {
      state.loadingSponsorsArray = loadingSponsorsArray;
    },
    setAddingingSponsor(state, addingSponsor) {
      state.addingSponsor = addingSponsor;
    },
    setEditingingSponsor(state, editingSponsor) {
      state.editingSponsor = editingSponsor;
    },
    setAddingAdmin(state, addingAdmin) {
      state.addingAdmin = addingAdmin;
    },
  },
  actions: {
    updateSponsorsData({ commit }, sponsors) {
      commit('updateSponsorsData', sponsors);
    },
    async fetchSponsors({ commit, rootGetters }) {
      try {
        commit('setLoadingSponsors', true);
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const planSponsorsGetList = planSponsorsGetListCtor({ axiosInstance });
        let sponsors;
        if(planSponsorsGetList) {
          sponsors = await planSponsorsGetList();
          commit('updateSponsors', camelify(sponsors));
        }
        commit('setLoadingSponsors', false);
        return sponsors;
      } catch(e) {
        commit('setLoadingSponsors', false);
        return Promise.reject(e);
      }
    },
    async fetchSponsor({ commit, rootGetters }, routeId) {
      commit('setLoadingSponsor', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const planSponsorGetDetails = getPlanSponsorDetailsCtor({ axiosInstance });
        let sponsor;
        if(planSponsorGetDetails) {
          sponsor = await planSponsorGetDetails(routeId);
          commit('updateSponsor', camelify(sponsor));
        }
        commit('setLoadingSponsor', false);
        return sponsor;
      } catch(e) {
        commit('setLoadingSponsor', false);
        return Promise.reject(e);
      } 
    },
    async fetchSponsorDetailsArray({ commit, rootGetters }, sponsorsIdArray) {
      commit('setLoadingSponsorsDetailsArray', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const planSponsorGetDetails = getPlanSponsorDetailsCtor({ axiosInstance });
        let sponsorsDetailsArray;
        if(planSponsorGetDetails) {
          sponsorsDetailsArray = await Promise.all(sponsorsIdArray.map(async (id) => { 
            const result = await planSponsorGetDetails(id); 
            return camelify(result);
          }));
          commit('updateSponsorsDetailsArray', sponsorsDetailsArray);
        }
        commit('setLoadingSponsorsDetailsArray', false);
        return sponsorsDetailsArray;
      } catch(e) {
        commit('setLoadingSponsorsDetailsArray', false);
        return Promise.reject(e);
      } 
    },
    async addSponsor({ commit, rootGetters }, data) {
      commit('setAddingingSponsor', true);
      try {
        const axiosInstance = restInstance(rootGetters?.ciToken || null);
        const planSponsorCreate = planSponsorCreateCtor({ axiosInstance });
        let added;
        if(planSponsorCreate) {
          added = await planSponsorCreate(data);
        }
        commit('setAddingingSponsor', false);
        return added;
      } catch(e) {
        commit('setAddingingSponsor', false);
        return Promise.reject(e);
      }
    },
    async editSponsor({ commit, rootGetters }, { id, data }) {
      commit('setEditingingSponsor', true);
      try {
        const axiosInstance = restInstance(rootGetters?.ciToken || null);
        const planSponsorEdit = planSponsorEditCtor({ axiosInstance });
        let edited;
        if(planSponsorEdit) {
          edited = await planSponsorEdit(id, data);
        }
        commit('setEditingingSponsor', false);
        return edited;
      } catch(e) {
        commit('setEditingingSponsor', false);
        return Promise.reject(e);
      }
    },
    async addAdmin({ commit, rootGetters }, data) {
      commit('setAddingAdmin', true);
      try {
        const axiosInstance = restInstance(rootGetters?.ciToken || null);
        const planSponsorAddAdmin = planSponsorAddAdminCtor({ axiosInstance });
        let added;
        if(planSponsorAddAdmin) {
          const added = await planSponsorAddAdmin(data);
        }
        commit('setAddingAdmin', false);
        return added;
      } catch(e) {
        commit('setAddingAdmin', false);
        return Promise.reject(e);
      }
    }
  },
};
